// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';
import { createRoot } from 'react-dom/client';

// Material UI ( mui ) components
import Box from '@mui/material/Box';

// Section for import custom components --------------------------------------------------------------------------------
import Header from '@components/layout/Header';
import TopComment from '@components/layout/TopComment';
import Footer from '@components/layout/Footer';
import MansionNavigation from '@components/MansionNavigation';
import MansionSearch from '@components/MansionSearch';
import MansionPopular from '@components/MansionPopular';
import RenovationVoice from '@components/RenovationVoice';
import Request from '@components/Request';
import Breadcrumbs from '@components/common/Breadcrumbs';
import App from './app';

// Section for import custom types -------------------------------------------------------------------------------------
import MansionNavigationProps from '@/types/components/MansionNavigation/MansionNavigationProps';

const targetId = 'app-content-index';

// Section for render component ----------------------------------------------------------------------------------------

// Render component if the targetID element exists in the DOM.
if (document.getElementById(targetId)) {
  const container = document.getElementById(targetId)!;
  const root = createRoot(container);

  const { props } = container.dataset;
  const propsData: MansionNavigationProps = JSON.parse(props!);
  const { isPrefectureSelect } = propsData;
  const { typeNavigation } = propsData;

  const breadcrumbs = container.dataset.breadcrumbs ? JSON.parse(container.dataset.breadcrumbs) : [];

  root.render(
    <App>
      <Header />
      <TopComment />
      <Box>
        <MansionNavigation
          isPrefectureSelect={isPrefectureSelect}
          typeNavigation={typeNavigation}
          selectedPrefecture={null}
          isCitySelect={false}
          selectedCity={null}
          isLineSelect={false}
          selectedLine={null}
          mansionsData={null}
          navigationName=""
        />
        <MansionSearch />
        <MansionPopular limit={40} title="人気のマンション" />
        <Box className="bg-gray-01 pt-16 max-md:pt-12 pb-14 max-md:pb-10">
          <RenovationVoice />
          <Request />
        </Box>
      </Box>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <Footer />
    </App>,
  );
}
